import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goHomeAnchor = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (window.location.pathname === '/') {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <footer className="bg-primary-100 border-t border-primary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-fill text-base"></i>
              </span>
              <span className="font-heading font-semibold text-lg text-foreground-900">USFansLink</span>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-foreground-700 hover:text-primary-600 cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/usfans-spreadsheet" className="text-foreground-700 hover:text-primary-600 cursor-pointer">
                  {t('a1.cardTitle')}
                </Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-700 hover:text-primary-600 cursor-pointer"
                >
                  {t('nav.browse')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">{t('footer.resources')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/usfans-spreadsheet" className="text-foreground-700 hover:text-primary-600 cursor-pointer">
                  {t('nav.guides')}
                </Link>
              </li>
              <li>
                <a href="#categories" onClick={goHomeAnchor('categories')} className="text-foreground-700 hover:text-primary-600 cursor-pointer">
                  {t('nav.categories')}
                </a>
              </li>
              <li>
                <a href="#safety" onClick={goHomeAnchor('safety')} className="text-foreground-700 hover:text-primary-600 cursor-pointer">
                  {t('nav.safety')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200">
          <p className="text-xs text-foreground-600 leading-relaxed">{t('footer.disclaimer')}</p>
          <p className="mt-3 text-xs text-foreground-600">
            © {new Date().getFullYear()} USFansLink.cfd · {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}